"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToleranceLines = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const ToleranceLines = ({ colour, size = 16, title = "Tolerance lines" }) => (react_1.default.createElement(Base_1.Base, { size: size, title: title },
    react_1.default.createElement("g", { fill: "none", strokeWidth: "2" },
        react_1.default.createElement("path", { stroke: colour !== null && colour !== void 0 ? colour : "#b1000d", d: "M2 2h12M2 14h12" }),
        react_1.default.createElement("path", { stroke: colour !== null && colour !== void 0 ? colour : "#efefef", strokeDasharray: "2,2", strokeDashoffset: "3", d: "M2 8h12" }))));
exports.ToleranceLines = ToleranceLines;
//# sourceMappingURL=ToleranceLines.js.map